import styled from "styled-components";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

export const ProgramInfoWrapper = styled.div`
	background-color: ${({ backgroundColor }) => backgroundColor};
	box-shadow: ${({ hasBoxShadow }) =>
		hasBoxShadow
			? "rgba(0, 0, 0, 0.01) 0px 78px 31px, rgba(0, 0, 0, 0.02) 0px 44px 26px, rgba(0, 0, 0, 0.03) 0px 20px 20px, rgba(0, 0, 0, 0.04) 0px 5px 11px, rgba(0, 0, 0, 0.04) 0px 0px 0px"
			: ""};

	width: 905px;
	border-radius: 8px;
	padding: 40px 0px;
	align-items: center;
	margin-top: ${({ topMargin }) => (topMargin ? `${topMargin}px` : "")};
	.content-wrapper p {
		color: ${({ darkBg }) =>
			darkBg
				? "var(--theme-light-font-color, var(--primary-neutral-white))"
				: "var(--primary-neutral-nightshade-600)"};
	}
	.program-info-grid {
		margin: 0 48px;
		grid-template-columns: 240px 10px 210px 10px 290px !important;
		gap: 12px;
		@media only screen and (max-width: ${TABLET_M_BP}px) {
			margin: 0 24px;
			grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
		}
	}
	.col-wrapper {
		height: 100%;
		@media only screen and (max-width: ${TABLET_M_BP}px) {
			&:not(last-child) {
				border-bottom: ${({ icon, darkBg }) =>
					icon
						? "none"
						: `1px solid ${
								darkBg ? "var(--secondary-gray-medium)" : "rgba(0,0,0,0.3)"
							}`};
				padding-bottom: 18px;
				width: auto;
			}
			&:last-child {
				border-bottom: none;
			}
		}
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		width: 100%;
		max-width: 350px;
	}
`;

export const InfoElementWrapper = styled.div`
	display: flex;
	height: 100%;
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		flex-direction: row;
	}
	.content-wrapper {
		padding: 0 16px;
		text-align: left;
	}
	.info-element {
		height: 100%;
	}
`;
